import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";

const Rail = styled.nav`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 48px;
    height: 100%;
    padding: 8px 4px;
    border-left: solid 1px var(--color-Line);
    background-color: var(--color-White);
`;

const RailDivider = styled.div`
    width: 20px;
    height: 1px;
    margin: 4px 0;
    background: var(--color-Line);
`;

const RailButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 0;
    border-radius: 4px;
    background-color: ${({ $active }) => ($active ? "var(--color-ButtonHover4)" : "transparent")};
    cursor: pointer;

    &:hover {
        background-color: var(--color-ButtonHover4);
    }
`;

function ManuscriptRightRail({ activePanel, onSelect, isCollapsed, onToggle }) {
    return (
        <Rail>
            <Tooltip message={isCollapsed ? "우측 사이드바 열기" : "우측 사이드바 닫기"}>
                <RailButton
                    type="button"
                    aria-label={isCollapsed ? "우측 사이드바 열기" : "우측 사이드바 닫기"}
                    onClick={onToggle}
                >
                    <Icon name={isCollapsed ? "arrowLeft" : "arrowRight"} size="12" color="var(--color-SubBlack)" />
                </RailButton>
            </Tooltip>
            <RailDivider />
            <Tooltip message="PDF" position="left">
                <RailButton
                    type="button"
                    aria-label="PDF"
                    $active={activePanel === "pdf" && !isCollapsed}
                    onClick={() => onSelect("pdf")}
                >
                    <Icon name={"pdf"} size={"16px"} color={"var(--color-SubBlack)"} />
                </RailButton>
            </Tooltip>
            <Tooltip message="히스토리" position="left">
                <RailButton
                    type="button"
                    aria-label="히스토리"
                    $active={activePanel === "history" && !isCollapsed}
                    onClick={() => onSelect("history")}
                >
                    <Icon name={"last"} size={"16px"} color={"var(--color-SubBlack)"} />
                </RailButton>
            </Tooltip>
            <Tooltip message="리뷰" position="left">
                <RailButton
                    type="button"
                    aria-label="리뷰"
                    $active={activePanel === "review" && !isCollapsed}
                    onClick={() => onSelect("review")}
                >
                    <Icon name={"thread"} size={"16px"} color={"var(--color-SubBlack)"} />
                </RailButton>
            </Tooltip>
        </Rail>
    );
}

export default ManuscriptRightRail;
